(function () {
    const mobMenuBtn = document.getElementById('openMobileMenu');

    if (mobMenuBtn) {
        mobMenuBtn.addEventListener('click', function () {
            document.body.classList.toggle('show-menu');
        });
    }

    let lastScroll = 0;

    window.addEventListener('scroll', function () {
        let scroll = window.scrollY;

        if (scroll >= 41 && lastScroll >= scroll) {
            document.body.classList.add('sticky-menu');
        } else {
            document.body.classList.remove('sticky-menu');
        }

        lastScroll = scroll;
    });
}());
